<template>
  <div class="wrap-bg">
    <div class="section-gap bg-controller">
      <div class="container">
        <div class="section-title-wrapper">
          <div class="fullscreen-row">
            <div
              class="col-sm-12 mx-auto text-center splash-s splash-container d-flex"
            >
              <h1 class="h1-larger">GEWINNSPIEL</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <h2>Schnapp' dir den Hauptgewinn!</h2>
            <p class="subheadline">
              Wien Energie und crossconnect verlosen im Rahmen des eSport Soccercup 2020 tolle Preise. <br>
Ganz einfach Anmeldeformular ausfüllen und mit etwas Glück bist du der Gewinner einer Playstation 5, FIFA Ultimate Team Points im Wert von 400€ sowie NEOH-Riegeln und Coca-Cola! 
            </p>
          </div>
        </div>

        <div class="row form-row">
          <!-- FORM -->
          <div
            class="col-sm-6 pt-3 pb-3 d-flex justify-content-center align-self-center"
          >
            <div class="container">
              <form v-on:submit.prevent="onSubmit">
                <div class="form-group">
                  <label for="firstName">Vorname*</label>
                  <input
                    v-model="firstName"
                    type="text"
                    class="form-control"
                    id="firstName"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="lastName">Nachname*</label>
                  <input
                    v-model="lastName"
                    type="text"
                    class="form-control"
                    id="lastName"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="email">E-Mail*</label>
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    pattern="^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$"
                    required
                  />
                </div>
                <div class="form-group">
                  <div
                    class="custom-control custom-checkbox custom-checkbox-orange"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input custom-control-input-orange"
                      id="customCheck1"
                      v-model="checkbox"
                      required
                    />
                    <label class="custom-control-label" for="customCheck1"
                      >Ich stimme der <router-link to="/datenschutz">Speicherung</router-link> meiner persönlichen Daten
                      (Vorname, Nachname, E-Mailadresse) zu, um am Gewinnspiel
                      teilzunehmen.</label
                    >
                  </div>
                </div>
                <button :disabled="isSending" class="btn btn-primary">
                  <span v-if="!isSending">Teilnehmen</span>
                  <span v-if="isSending">Senden...</span>
                </button>
              </form>
            </div>
          </div>
          <!-- IMAGE -->
          <div
            class="col-sm-6 pt-3 pb-3 d-flex justify-content-center align-self-center"
          >
            <!-- <div class="tropy-image-container "> -->
            <div class="trophy-image-placeholder splash-image">
              <img
                id="trophyPrice"
                class="img-fluid"
                src="/static/img/preiscollage.png"
                alt="Trophy Price"
              />
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!--Toast -->
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      class="toast"
      id="successToast"
      data-autohide="true"
      data-animation="true"
      data-delay="4000"
    >
      <div class="toast-header">
        <strong class="mr-auto">eSport Soccercup ⚽</strong>
        <button
          type="button"
          class="ml-2 mb-1 close"
          data-dismiss="toast"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        <b
          >Vielen Dank für die Teilnahme am Gewinnspiel, wir haben Deine
          E-Mailadresse erhalten!</b
        >
      </div>
    </div>
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      class="toast"
      id="errorToast"
      data-autohide="true"
      data-animation="true"
      data-delay="4000"
    >
      <div class="toast-header">
        <strong class="mr-auto">eSport Soccercup ⚽</strong>
        <button
          type="button"
          class="ml-2 mb-1 close"
          data-dismiss="toast"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        <b
          >Leider ist ein Problem aufgetreten, bitte versuche es zu einem
          späteren Zeitpunkt nocheinmal!</b
        >
      </div>
    </div>
  </div>
</template>

<script>
import server from "../../utils/server.js";
import Email from "../../utils/smtp.js";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      checkbox: false,
      isSending: false,
    };
  },
  methods: {
    async onSubmit() {
      if (
        this.firstName == "" ||
        this.lastName == "" ||
        this.email == "" ||
        this.checkbox == false
      ) {
        // console.log("Bitte fülle die entsprechenden Felder aus.");
      } else {
        try {
          document.getElementById('successToast').style.zIndex = "100"
          document.getElementById('errorToast').style.zIndex = "100"
          this.isSending = true;
          var sanitizedFirstName = this.$sanitize(this.firstName);
          var sanitizedLastName = this.$sanitize(this.lastName);
          var sanitizedEmail = this.$sanitize(this.email);
          Email.send({
            SecureToken: server.token,
            To: server.receiver,
            From: server.username,
            Subject: "eSport Soccercup Gewinnspiel",
            Body:
              "<html><h2>eSport Soccercup Gewinnspiel</h2><strong>Vor- und Nachname: </strong>" +
              sanitizedFirstName +
              " " +
              sanitizedLastName +
              "<br></br><strong>E-Mail Adresse: </strong>" +
              sanitizedEmail +
              "</html>",
          }).then((message) => {
            if (message == "OK") {
              //   console.log(message);
              this.resetForm();
              this.showSuccessToast();
              this.resetToastCSS();
            } else {
              // console.log(message);
              this.resetForm();
              this.showErrorToast();
              this.resetToastCSS();
            }
          });
        } catch (error) {
          //   console.log("Error sending email", error);
          this.showErrorToast();
          this.resetForm();
          this.resetToastCSS();
        }
      }
    },
    showSuccessToast() {
      $("#successToast").toast("show");
    },
    showErrorToast() {
      $("#errorToast").toast("show");
    },
    resetForm() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.checkbox = false;
      this.isSending = false;
    },
    resetToastCSS(){
      $('#successToast').on('hidden.bs.toast', function () {
        document.getElementById('successToast').style.zIndex = "0"
        document.getElementById('errorToast').style.zIndex = "0"
      })
      $('#errorToast').on('hidden.bs.toast', function () {
        document.getElementById('successToast').style.zIndex = "0"
        document.getElementById('errorToast').style.zIndex = "0"
      })
    }
  },
};
</script>

<style scoped>
.wrap-bg {
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.6)
    ),
    url("/static/img/background_muster_10.png") !important;
  background-position: 100% 100% !important;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat !important;
}
@media (hover: none) {
  .wrap-bg {
    background-attachment: initial !important;
    background-position: center !important;
  }
}

.subheadline {
  font-size: 1.5em;
}

.splash-s {
  background-image: url(/static/img/splash-l.png), url(/static/img/splash-r.png);
  background-position: 6% 80%, 65% 45%;
  background-repeat: no-repeat;
  min-height: 200px;
}

.splash-image {
  background-image: url(/static/img/splash-r.png);
  background-position: 95% 3%;
  background-repeat: no-repeat;
  min-height: 200px;
  background-size: 90px;
}
.splash-container {
  justify-content: center;
  align-items: center;
}

.bg-controller {
  background-image: url(/static/img/controller10l.png);
  background-repeat: no-repeat;
  background-position: -10% 80%;
  background-size: 400px;
}

@media screen and (max-width: 600px) {
  .h1-larger {
    font-size: 3em;
  }
  h2 {
    font-size: 2em;
  }
  .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: -10% 80%, 90% 50% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 140px, 80px;
    min-height: 200px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1000px) {
  .h1-larger {
    font-size: 3em;
  }
  h2 {
    font-size: 2em;
  }
  .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: 10% 80%, 68% 45% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 220px, 90px;
    min-height: 200px;
  }
}

.fullscreen-row {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}
.fullscreen-row:before,
.fullscreen-row:after {
  display: table;
  content: " ";
}
.fullscreen-row:after {
  clear: both;
}

#successToast,
#errorToast {
  position: fixed;
  top: 0;
  right: 0;
  margin: 20px;
  z-index: 0;
}

.toast-body {
  background-color: #eb6626;
  color: #fff;
}

#errorToast > .toast-body {
  background-color: red;
}

label {
  color: #fff;
}

.custom-control-input-orange:focus ~ .custom-control-label::before {
  border-color: #eb6626 !important;
  box-shadow: 0 0 0 0.2rem rgba(235, 102, 38, 0.25) !important;
  color: #fff;
}

.custom-control-input-orange:checked ~ .custom-control-label::before {
  border-color: #eb6626 !important;
  background-color: #eb6626 !important;
  color: #fff;
}

.custom-control-input-orange:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #eb6626 !important;
  color: #fff;
}

.custom-control-input-orange:not(:disabled):active
  ~ .custom-control-label::before {
  background-color: #637282 !important;
  border-color: #637282 !important;
  color: #fff;
}

.custom-control-label:before {
  background-color: #202020;
  color: #fff;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: black;
  color: #fff;
}

.form-control {
  background-color: #202020;
  border: none;
  border-radius: 0px;
  color: #fff;
}

.form-control:focus {
  color: #fff;
}

.form-control:focus {
  background-color: #202020;
  -webkit-box-shadow: 0 0 0 0.1rem rgba(235, 102, 38, 0.7);
  box-shadow: 0 0 0 0.1rem rgba(235, 102, 38, 0.7);
}

.form-row {
  margin-top: 80px;
}

.tropy-image-container {
  background-color: #202020;
}

.trophy-image-placeholder {
  max-width: 400px;
  /* max-height: 400px; */
  background-color: #202020;
}

#trophyPrice {
  padding: 30px;
}

.btn-primary {
  border-radius: 0px;
  background-color: transparent;
  color: #eb6626;
}

.btn-primary:disabled {
  border-radius: 0px;
  background-color: transparent;
  color: #fff;
}
</style>